import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";

type CreateUserProps = {
  onUserCreated: (file: File) => void;
};

const CreateUser = (props: CreateUserProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [file, setFile] = useState<File | null>(null);

  function handleChange(e: any) {
    setFile(e.target.files[0]);
  }

  function handleClick() {
    if (file) {
      props.onUserCreated(file);
    }
    onClose();
  }

  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme="teal" onClick={onOpen}>
        Crear Usuarios
      </Button>
      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Nuevos usuarios</ModalHeader>
          <ModalBody>
            <FormControl id="file-form-control" paddingBottom="6">
              <FormLabel>Usuarios</FormLabel>
              <input name="file-input" type="file" onChange={handleChange} />
              <FormHelperText>
                Seleccione un archivo en formato xlsx.
              </FormHelperText>
            </FormControl>
          </ModalBody>
          <ModalCloseButton />
          <ModalFooter>
            <Button
              colorScheme="teal"
              type="submit"
              isDisabled={!file}
              onClick={handleClick}
            >
              Crear
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CreateUser;